import React from 'react'
import { VehicleSource } from '@cbgms/api'
import { useOrderAccountsContext } from 'app/workorder/contexts/use-order-account-context'

export const usePrimaryVehicleSource = () => {
  const { selectedOrderAccount } = useOrderAccountsContext()
  return React.useMemo(
    () => ({
      source: selectedOrderAccount?.Catalog?.VehiclePrimaryVehicleSource || VehicleSource.CARSYS_HBASE,
      isVPOM: !!(selectedOrderAccount?.Catalog?.VehiclePrimaryVehicleSource || '').match(/VPOM.*/i)
    }),
    [selectedOrderAccount?.Catalog?.VehiclePrimaryVehicleSource]
  )
}
